var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.authToken)?_c('VulcanAuthForm',{attrs:{"authorize":_vm.authorize}}):_c('VulcanPickerForm',{attrs:{"authToken":_vm.authToken,"openChart":_vm.openChart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }